import { render, staticRenderFns } from "./ListagemSupportSubjects.vue?vue&type=template&id=2dc3ec7e"
import script from "./ListagemSupportSubjects.vue?vue&type=script&lang=js"
export * from "./ListagemSupportSubjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports